import React, { useMemo } from 'react';
import { RoomMockup } from '../components/fabric/RoomMockup';
import { shadeQuad } from '../components/fabric/roomScenes';
import { SHOWROOM_CANDIDATES } from '../components/fabric/showroomCandidates';
import { resolveImageUrl } from '../lib/imageCache';

const TEXTURE = '/api/storage/files/apollo-shades/fabrics/cdn-original/774b3a4e-921c-4c8c-bf5d-0ae4f9fe0b4f.jpg';

/* Internal review page: every showroom candidate rendered by the real Simulator engine
   with per-window presentation drops (see showroomCandidates.js). */
export default function ShowroomFitPage() {
  const textureUrl = resolveImageUrl(TEXTURE, 512);
  const light = useMemo(() => ({ mode: 'screen', label: 'Solar Screen', options: [1, 3, 5, 10] }), []);
  return (
    <div className="min-h-screen bg-neutral-100 p-4" data-testid="showroom-fit-page">
      <div className="grid grid-cols-6 gap-3">
        {SHOWROOM_CANDIDATES.filter(c => c.selected).map(c => {
          const scene = { ...c, shades: c.shades.map(s => ({ ...s, quad: shadeQuad(s.quad, s.drop) })) };
          return (
            <div key={c.id} className="bg-white" data-testid={`showroom-card-${c.id}`}>
              <RoomMockup scene={scene} ambience="day" textureUrl={textureUrl} hexColor="#b9b2a8" light={light} openness={5} drop={1} animate={false} />
              <p className="text-xs px-2 py-1 text-neutral-700">{c.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
